<input type="file" (change)="fileChangeEvent($event)" id="image" style="display: none;"/>

<div class="my-4">
    <label for="image" class="label">
        Scegli un'immagine
    </label>
</div>

<div class="mt-3">
    <div class="grid">
        <div class="col-6">
            <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="false"
                format="jpeg"
                [imageQuality]="90"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded($event)"
                (cropperReady)="cropperReady()"
                (loadImageFailed)="loadImageFailed()"
            ></image-cropper>
        </div>
        <div class="col-6">
            <img class="w-full" [src]="croppedImage" />
        </div>
    </div>
</div>

<div class="modal-footer flex justify-content-between">
    <div class="w-full">
        <p-button label="Annulla" size="small" (click)="close()" [outlined]="true"></p-button>
    </div>
    <div class="w-full ml-3">
        <p-button label="Salva" size="small" (click)="save()" styleClass="slide-o"></p-button>
    </div>
</div>
